import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "apple",
  "use": "apple-usage",
  "viewBox": "0 0 21.76 26.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21.76 26.9\" fill-rule=\"evenodd\" id=\"apple\"><defs><style>#apple .fil0{fill:#1b86c7}</style></defs><g id=\"apple_Layer_x0020_1\"><g id=\"apple__2180358751616\"><path class=\"fil0\" d=\"M16.41 14.27c0 2.31 1.55 5.62 3.21 6.06-.21.92-1.99 3.57-2.62 4.16-1.64 1.52-2.02-.41-6.12-.41-1.73 0-2.95 1.1-3.93 1.04-1.87-.11-5.17-6.18-5.17-10.13 0-2.65.36-4.44 2.47-5.92 2.62-1.83 4.32.39 6.99.39 2.02 0 3.61-2.23 7.14-.54-.09 1.11-1.96 2.02-1.96 5.35zm-5.35-6.6C9.11 7.67 9.6 6.6 6.07 6.6 3.01 6.6.01 10.11.01 13.91c0 3.42.56 5.7 2.08 8.44 4.12 7.43 6.32 3.51 8.8 3.51 3.28 0 2.48.74 4.55.97 3.51.38 6.26-6.29 6.33-7.21-2.3-.53-4.99-4.64-2.67-8.38 1.02-1.64 1.37-1.27 1.96-2.15-1.48-2.21-4.55-3.12-7.28-2.28-.79.24-1.72.86-2.71.86zM10.7 6.24c1.92 0 2.97-.52 4.23-2.01.97-1.15 1.3-2.18 1.3-4.23-3.06.25-5.53 2.86-5.53 6.24z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/apple.svg
// module id = tsZG
// module chunks = 38 43